import type { SagaMiddleware } from "redux-saga";
import { uhfSagas } from "@gamedev-web/gamedev-uhf";

import { appContextSagas } from "./appContextSagas";
import { navigationSagas } from "./navigationSagas";

export const runSagas = (middleware: SagaMiddleware) => {
  const sagas = [
    uhfSagas,
    navigationSagas,
    appContextSagas, // appContextSagas needs to be after userConsentServiceSagas!
  ];
  sagas.forEach(saga => {
    middleware.run(saga);
  });
};
